export const isMobile = (): boolean => {
    return window.innerWidth < 760;
};
